import { combineReducers } from 'redux'
import auth from './auth'
import notification from './auth/notificationSlice'
import list from './auth/listSlice'
import locale from './locale/localeSlice'
import admin from './admin'
import user from './user'
import storeUser from './storeUser'

const rootReducer = asyncReducers => (state, action) => {
    const combinedReducer = combineReducers({
        auth,
        notification,
        list,
        locale,
        admin,
        user,
        storeUser,
        ...asyncReducers,
    })
    return combinedReducer(state, action)
}

export default rootReducer
